/**
 * Media Metafield Color Filtering
 * Shows only images with matching color tag
 */

(function () {
  'use strict';

  function initColorFilter() {
    const productMediaGrid = document.querySelector('.product-media__grid--mango');

    if (!productMediaGrid) {
      return;
    }

    // Get all media items with color tags
    const mediaItems = productMediaGrid.querySelectorAll('[data-color-tag]');

    function filterByColor(selectedColor) {
      if (!selectedColor) {
        showAllMedia();
        return;
      }

      // Extract color code from parentheses (e.g., "TAN (T002)" -> "T002")
      const codeMatch = selectedColor.match(/\(([^)]+)\)/);
      const colorCode = codeMatch ? codeMatch[1].trim() : '';

      if (!colorCode) {
        showAllMedia();
        return;
      }

      let visibleCount = 0;

      mediaItems.forEach(item => {
        const imageColorTag = item.getAttribute('data-color-tag') || '';

        // Direct match with color code from filename
        if (imageColorTag === colorCode) {
          item.style.display = '';
          item.classList.remove('is-hidden');
          visibleCount++;
        } else {
          item.style.display = 'none';
          item.classList.add('is-hidden');
        }
      });

      if (visibleCount === 0) {
        showAllMedia();
      }
    }

    function showAllMedia() {
      mediaItems.forEach(item => {
        item.style.display = '';
        item.classList.remove('is-hidden');
      });
    }

    // Listen to color option changes
    const colorInputs = document.querySelectorAll('input[type="radio"][name="option1"]');

    function onColorChange() {
      const selectedInput = document.querySelector('input[type="radio"][name="option1"]:checked');

      if (selectedInput) {
        const selectedColor = selectedInput.value;
        filterByColor(selectedColor);
      }
    }

    // Add listeners
    colorInputs.forEach(input => {
      input.addEventListener('change', onColorChange);
    });

    // Initial filter on page load
    onColorChange();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorFilter);
  } else {
    initColorFilter();
  }
})();
